<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    doughnutLabel: {
      type: [Array],
      default: () => []
    },
    doughnutData: {
      type: [Array],
      default: () => []
    },
    doughnutColor: {
      type: [Array],
      default: () => [
            '#41B883',
            '#E46651',
            '#00D8FF',
            '#DD1B16',
            '#7a77d1',
            '#8fc74a',
            '#6e0a2d',
            '#66a832',
            '#5d5e51',
            '#5b515e',
            '#ddccff',
            '#b3ffb3',
            '#009900'
          ]
    }
  },
  mounted () {
    this.renderChart({
      labels: this.doughnutLabel,
      datasets: [
        {
          backgroundColor: this.doughnutColor,
          data: this.doughnutData
        }
      ]
    }, {responsive: true, maintainAspectRatio: true})
  }
}
</script>
